import { DocsPageView } from './DocsPageView'

export function DocsHomePage() {
  return <DocsPageView slug="" />
}
